export default "__VITE_ASSET__BPGUH$OP__"